































































import { Vue, Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { monthCardsmsRecord, getSmsTemplate, exportSmsRecord } from '@/api/fixed-car-management';
import Utils from '@root/utils/common';
import moment from 'moment';
// 字典
import { sendStatusMap } from '@/types/fixed-car-management/dictionaries';

interface MessageCollectionRecordType {
  [k: string]: any;
}

@Component
export default class MessageCollectionRecord extends Mixins(TableMixin, TableWidthMixin)
  implements MessageCollectionRecordType {
  // 操作类型
  current = 1;
  private moment = moment;
  private sendStatusList = Utils.toLabelVal(sendStatusMap);
  private filterParam: any = {
    start: moment()
      .startOf('d')
      .format('YYYY-MM-DD HH:mm:ss'), // 时间-开始
    end: moment()
      .startOf('d')
      .format('YYYY-MM-DD 23:59:59'), // 时间-结束
    smsId: '', //
    sendStatus: '',
    phoneNum: ''
  };
  private tableLoading = false;
  private tableData: any[] = []; // 表数据
  downloadFlag: boolean = false;
  optionList: any[] = [];
  get defaultTime() {
    if (this.filterParam.start && this.filterParam.end) {
      return [
        this.moment(this.filterParam.start, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.end, 'YYYY-MM-DD HH:mm:ss')
      ];
    }
    if (this.filterParam.start) {
      return [this.moment(this.filterParam.start, 'YYYY-MM-DD HH:mm:ss').startOf('d')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '发送时间',
        dataIndex: 'sendTime',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '接收时间',
        dataIndex: 'receiveTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '手机号',
        dataIndex: 'phone',
        width: 160
      },
      {
        title: '姓名',
        dataIndex: 'name',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '套餐',
        dataIndex: 'packageName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车位',
        dataIndex: 'spaceCode',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '车牌',
        dataIndex: 'plate',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '短信模板',
        dataIndex: 'templateName',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '发送状态',
        dataIndex: 'sendStatus',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '失败原因',
        dataIndex: 'failReason',
        width: 200,
        customRender: (text: any) => text || '--'
      }
    ];
  }

  created() {
    this.getSmsTemplateList();
    this.fetchTableData();
  }

  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { ...rest } = this.filterParam;
      const { status, code, msg, data } = await monthCardsmsRecord({
        ...rest,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
      this.total = +totalNum;
      this.tableData = datas;
      this.total = +totalNum;
      this.current = +currPage;
      this.pageSize = +pageSize;
    } catch (error) {
      console.log(error);
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.fetchTableData(true);
  }
  /**
   * 点击清除按钮
   **/

  private onTableFilterClear() {
    this.filterParam = {
      start: moment()
        .startOf('d')
        .format('YYYY-MM-DD HH:mm:ss'), // 时间-开始
      end: moment()
        .startOf('d')
        .format('YYYY-MM-DD 23:59:59'), // 时间-结束
      smsId: '', //
      sendStatus: '',
      phoneNum: ''
    };
    this.fetchTableData();
  }

  // 入场时间改变
  onEnterTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = dateString;
    this.filterParam.start = startTime;
    this.filterParam.end = endTime;
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  /**
   * 导出
   */
  private async download() {
    const today = moment(new Date()).format('YYYY-MM-DD');
    try {
      const { current = '', pageSize = '' } = this;
      const params = {
        ...this.filterParam,
        currPage: current,
        pageSize
      };
      if (this.downloadFlag) return;
      this.downloadFlag = true;
      await exportSmsRecord(
        {
          ...params
        },
        `短信发送记录-${today}`
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.downloadFlag = false;
    }
  }
  //获取模板列表
  async getSmsTemplateList() {
    try {
      const { data } = await getSmsTemplate({});
      this.optionList = data;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
}
